import React, { Component } from 'react';

import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid, Paper, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';


import AbEnvironment from '../auth/AbEnvironment';

import BusinessIdentityDocumentFetch from './BusinessIdentityDocumentFetch';
import BusinessBeneficialOwnerDocumentFetch from './BusinessBeneficialOwnerDocumentFetch';
import PageTitle from '../ui/PageTitle';
import AppBindStyles from '../../AppBindStyles';

import { format } from 'date-fns';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    },  
    tblHead: {
      backgroundColor: '#f1f1f1'
    },
});
  
class DocumentViewer extends Component {
    state = {
        showSpinner: false,
        showSecondarySpinner: false,
        saveStatus: null,
        saveMessage: null,
        snackbarOpen: false,
        confirmDelete: false,
        confirmSend: false,    

        created: '',
        documentType: '',
        dwollaStatus: ''
    }

    componentDidMount() {
      const params = new URLSearchParams(this.props.location.search);
      let bidId = params.get('bidId');
      let bodId = params.get('bodId');
      let dwollaId = params.get('dId');
      if (bidId) {
        this.fetchBusinessIdentityDocument(bidId);
      } else if (bodId) {
        this.fetchBeneficialOwnerDocument(bodId);
      }

     this.getDwollaDocument(dwollaId);
    }

    fetchBusinessIdentityDocument = (bidId) => {
      
      BusinessIdentityDocumentFetch.fetch(bidId).toPromise()
      .then(df => {
         if (df.businessIdentityDocTByBidId) {

          var documentType = '';
          if (df.businessIdentityDocTByBidId.documentType === 0) {
            documentType = 'EIN letter';
          } else if (df.businessIdentityDocTByBidId.documentType === 1) {
            documentType = 'Fictitious Business Name Statement'
          } else if (df.businessIdentityDocTByBidId.documentType === 2) {
            documentType = 'Certificate of Assumed Name'
          } else if (df.businessIdentityDocTByBidId.documentType === 3) {
            documentType = 'Business License'
          } else if (df.businessIdentityDocTByBidId.documentType === 4) {
            documentType = 'Sales/Use Tax License'
          } else if (df.businessIdentityDocTByBidId.documentType === 5) {
            documentType = 'Registration of Trade Name'
          } else if (df.businessIdentityDocTByBidId.documentType === 6) {
            documentType = 'Government-issued photo ID'
          }

          this.setState({created: df.businessIdentityDocTByBidId.created, documentType: documentType, dwollaStatus: df.businessIdentityDocTByBidId.dwollaStatus});
         }
      })
      .catch(err => {
        //nothing to do....
      })
    }

    fetchBeneficialOwnerDocument = (bodId) => {
      
      BusinessBeneficialOwnerDocumentFetch.fetch(bodId).toPromise()
      .then(df => {
         if (df.beneficialOwnerDocTByBodId) {

          let documentType = ''
          if (df.beneficialOwnerDocTByBodId.documentType === 0) {
            documentType = 'Drivers license';
          } else if (df.beneficialOwnerDocTByBodId.documentType === 1) {
            documentType = 'Passport'
          } else if (df.beneficialOwnerDocTByBodId.documentType === 2) {
            documentType = 'Other government issued id'
          }

          this.setState({created: df.beneficialOwnerDocTByBodId.created, documentType: documentType, dwollaStatus: df.beneficialOwnerDocTByBodId.dwollaStatus});
         }
      })
      .catch(err => {
        //nothing to do....
      })
    }

    getDwollaDocument(dwollaId) {
      const { callPartnerApi } = this.props.auth;
   
      let aPjwt = abEnvironment.getPjwt();

      if (dwollaId) {
        // Call server side to get status of this beneficial owner.
        let payload = {
          operation: "getDwollaDocument",
          params: {
            pJwt:      aPjwt,
            documentId: dwollaId
          }
        };
    
        callPartnerApi('appbind/generic',
                      'POST',
                      payload
        ).then(resp => {
          return resp.json();
        }).then(data => {
          //console.log(data.body);
          if (data.body && data.body.allFailureReasons) {
            this.setState({failureReasons: data.body.allFailureReasons});
          }
 
        }).catch(reason => {
          console.log('Failure getting document: ' + reason);
        });      

      }


    }

    goBack() {
      this.props.history.goBack();
    }
    
    goTo(route) {
      this.props.history.replace(`/${route}`);
    }


    showSpinner() {
        return this.state.showSpinner;
    }

    

    render() {
        const { isAuthenticated, isAuthenticatedReseller, needAssent } = this.props.auth;
        const classes = this.props.classes;
    

        if (!isAuthenticated() || needAssent()) {
          return (
            <Redirect to='/home' />
          );
        } else if (isAuthenticatedReseller()) {


          const params = new URLSearchParams(this.props.location.search);
          let bodId = params.get('bodId');

          let backButtonText = 'Business Identity';
          if (bodId) {
            backButtonText = 'Business Owner'
          }

          let createdDate = '';
          if (this.state.created) {
            createdDate = format(new Date(this.state.created+'Z'), 'yyyy-MM-dd pp');
          }

          let reasonCount = 0;

          return (
            <div id="document-viewer" className={classes.root}>
              <PageTitle title="Document failure reason" showBackButton={true} name={backButtonText} history={this.props.history}/>

              <Paper className={classes.paper}>
                <Grid container spacing={2} direction="row" justifyContent="flex-start">                      

                  <Grid item xs={12} sm={6}>
                      <TextField 
                      id="uploadedDate" label="Date uploaded"
                      value={ createdDate }
                      InputProps={{ readOnly: true, disableUnderline: true }}
                      />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                      <TextField 
                      id="documentType" label="Document type"
                      value={ this.state.documentType }
                      InputProps={{ readOnly: true, disableUnderline: true }}
                      />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                      <TextField 
                      id="documentStatus" label="Document status"
                      value={ this.state.dwollaStatus }
                      InputProps={{ readOnly: true, disableUnderline: true }}
                      />
                  </Grid>

                  {this.state.failureReasons && this.state.failureReasons.length > 0 &&
                      <React.Fragment>
                        <Grid item xs={12}>
                          <Grid container spacing={1} alignItems="center">
                            <Grid item>
                              <Typography variant="h6" style={AppBindStyles.sectionTitleTable}>
                                Failure reason(s)
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12}>
                          <TableContainer>
                              <Table>
                                <TableHead className={classes.tblHead}>
                                  <TableRow>
                                    <TableCell className={classes.tableCellPadding}>Reason given</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {this.state.failureReasons.map(r => {

                                  
                                    return(
                                      <TableRow key={reasonCount++}>
                                        <TableCell className={classes.tableCellPadding}>{r.description}</TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>

                        </Grid>
                      </React.Fragment>
                  }

                </Grid>
              </Paper>

            </div>

          );

       } else {
          return (
            <Redirect to='/home' />
          );
        }
    }

}

DocumentViewer.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(DocumentViewer);